<ng-container>
  <div class="business-license-content">
    <img [src]="setMediaUrl(mediaUrl$ | async)" />
  </div>
</ng-container>
